//# sourceMappingURL=image.mjs.map
/// <reference types="./image.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $regexp from "../../../gleam_regexp/gleam/regexp.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $html_parser from "../../common/html_parser.mjs";
import * as $document_context from "../../data/docx/document_context.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import * as $decrypt from "../../decrypt.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
} from "../../gleam.mjs";

const FILEPATH = "src/data/docx/image.gleam";

export class Image extends $CustomType {
  constructor(doc_context, html_tag, metadata) {
    super();
    this.doc_context = doc_context;
    this.html_tag = html_tag;
    this.metadata = metadata;
  }
}
export const Image$Image = (doc_context, html_tag, metadata) =>
  new Image(doc_context, html_tag, metadata);
export const Image$isImage = (value) => value instanceof Image;
export const Image$Image$doc_context = (value) => value.doc_context;
export const Image$Image$0 = (value) => value.doc_context;
export const Image$Image$html_tag = (value) => value.html_tag;
export const Image$Image$1 = (value) => value.html_tag;
export const Image$Image$metadata = (value) => value.metadata;
export const Image$Image$2 = (value) => value.metadata;

export class Metadata extends $CustomType {
  constructor(content_type, base64_data, kind) {
    super();
    this.content_type = content_type;
    this.base64_data = base64_data;
    this.kind = kind;
  }
}
export const Metadata$Metadata = (content_type, base64_data, kind) =>
  new Metadata(content_type, base64_data, kind);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$content_type = (value) => value.content_type;
export const Metadata$Metadata$0 = (value) => value.content_type;
export const Metadata$Metadata$base64_data = (value) => value.base64_data;
export const Metadata$Metadata$1 = (value) => value.base64_data;
export const Metadata$Metadata$kind = (value) => value.kind;
export const Metadata$Metadata$2 = (value) => value.kind;

function metadata_decoder() {
  return $decrypt.optional_field(
    "kind",
    $kind.decoder(),
    (kind) => {
      return $decode.field(
        "content_type",
        $decode.string,
        (content_type) => {
          return $decode.field(
            "base64_data",
            $decode.string,
            (base64_data) => {
              return $decode.success(
                new Metadata(content_type, base64_data, kind),
              );
            },
          );
        },
      );
    },
  );
}

export function decoder() {
  return $decrypt.optional_field(
    "doc_context",
    $document_context.decoder(),
    (doc_context) => {
      return $decrypt.optional_field(
        "html_tag",
        $decode.string,
        (html_tag) => {
          let html_tag$1 = $option.unwrap(html_tag, "img");
          return $decrypt.optional_field(
            "metadata",
            metadata_decoder(),
            (metadata) => {
              let metadata$1 = $option.unwrap(
                metadata,
                new Metadata("", "", new None()),
              );
              return $decode.success(
                new Image(doc_context, html_tag$1, metadata$1),
              );
            },
          );
        },
      );
    },
  );
}

function format_to_src(image) {
  return (("data:" + image.metadata.content_type) + ";base64,") + image.metadata.base64_data;
}

export function to_html(image) {
  let img = (_capture) => { return $h.element("img", _capture, toList([])); };
  let image_source_attribute = $a.attribute("src", format_to_src(image));
  let _block;
  let $ = image.doc_context;
  if ($ instanceof Some) {
    let ctx = $[0];
    let doc_context_attrs = $document_context.to_html_attributes(ctx);
    _block = listPrepend(image_source_attribute, doc_context_attrs);
  } else {
    _block = toList([image_source_attribute]);
  }
  let image_attributes = _block;
  let class$ = $a.class$("pm-image");
  let editable = $a.content_editable(false);
  return img(listPrepend(class$, listPrepend(editable, image_attributes)));
}

function metadata_encoder(metadata) {
  return $json.object(
    toList([
      ["kind", $json.nullable(metadata.kind, $kind.encode)],
      ["content_type", $json.string(metadata.content_type)],
      ["base64_data", $json.string(metadata.base64_data)],
    ]),
  );
}

export function encode(image) {
  return $json.object(
    toList([
      ["type", $json.string("image")],
      [
        "doc_context",
        $json.nullable(image.doc_context, $document_context.encode),
      ],
      ["html_tag", $json.string(image.html_tag)],
      ["metadata", metadata_encoder(image.metadata)],
    ]),
  );
}

export function from_html(html) {
  let _block;
  let _pipe = $string.trim(html);
  _block = $string.starts_with(_pipe, "<img");
  let is_image = _block;
  return $bool.guard(
    !is_image,
    new Error(undefined),
    () => {
      let element = $html_parser.as_tree(html);
      let doc_context = $document_context.from_html_attributes(element);
      let _block$1;
      let _pipe$1 = $html_parser.extract_attribute("src", element);
      let _pipe$2 = $option.from_result(_pipe$1);
      _block$1 = $option.unwrap(_pipe$2, "");
      let source_content = _block$1;
      let $ = $regexp.from_string("data:([^;]+);base64,(.+)");
      let image_src_regex;
      if ($ instanceof Ok) {
        image_src_regex = $[0];
      } else {
        throw makeError(
          "let_assert",
          FILEPATH,
          "data/docx/image",
          103,
          "from_html",
          "Pattern match failed, no pattern matched the value.",
          {
            value: $,
            start: 2916,
            end: 2999,
            pattern_start: 2927,
            pattern_end: 2946
          }
        )
      }
      let _block$2;
      let $2 = $regexp.scan(image_src_regex, source_content);
      if ($2 instanceof $Empty) {
        _block$2 = ["", ""];
      } else {
        let $3 = $2.tail;
        if ($3 instanceof $Empty) {
          let match = $2.head;
          let $4 = match.submatches;
          if ($4 instanceof $Empty) {
            _block$2 = ["", ""];
          } else {
            let $5 = $4.head;
            if ($5 instanceof Some) {
              let $6 = $4.tail;
              if ($6 instanceof $Empty) {
                _block$2 = ["", ""];
              } else {
                let $7 = $6.head;
                if ($7 instanceof Some) {
                  let $8 = $6.tail;
                  if ($8 instanceof $Empty) {
                    let content_type = $5[0];
                    let base64_data = $7[0];
                    _block$2 = [content_type, base64_data];
                  } else {
                    _block$2 = ["", ""];
                  }
                } else {
                  _block$2 = ["", ""];
                }
              }
            } else {
              _block$2 = ["", ""];
            }
          }
        } else {
          _block$2 = ["", ""];
        }
      }
      let $1 = _block$2;
      let content_type = $1[0];
      let base64_data = $1[1];
      return new Ok(
        new Image(
          new Some(doc_context),
          "img",
          new Metadata(content_type, base64_data, new $option.None()),
        ),
      );
    },
  );
}

export function update_kind(image, kind) {
  let _block;
  let _record = image.metadata;
  _block = new Metadata(
    _record.content_type,
    _record.base64_data,
    new Some(kind),
  );
  let metadata = _block;
  return new Image(image.doc_context, image.html_tag, metadata);
}
